<template>
<div class="login">
    <form id="form_start" method="POST" action="/start">
        <div id="login-headline"><h3>My Info</h3></div>
        <label for="login_first_name" class="is-hidden">First Name</label>
        <input v-model="first_name" id="login_first_name" type="text" name="first_name" placeholder="First Name">
        <label for="login_last_name" class="is-hidden">Last Name</label>
        <input v-model="last_name" id="login_last_name" type="text" name="last_name" placeholder="Last Name">
        <label for="login_email" class="is-hidden">Email</label>
        <input id="login_email" type="text" name="email" v-model="email" placeholder="Email Address">
        <label for="login_email_confirm" class="is-hidden">Confirm Email</label>
        <input v-model="email_confirm" id="login_email_confirm" type="text" name="email_confirm" placeholder="Confirm Email Address">
        <small>You&rsquo;ll use this email to sign in to your account, so make sure it is correct.</small>
        <div id="age-wrapper">
            <label class="is-big">Your age range</label>
            <input v-model="age" id="login_age_18" type="radio" name="age" value="18" class="is-hidden">
            <label for="login_age_18" class="age">18-25</label>
            <input v-model="age" id="login_age_26" type="radio" name="age" value="26" class="is-hidden">
            <label for="login_age_26" class="age">26-35</label>
            <input v-model="age" id="login_age_36" type="radio" name="age" value="36" class="is-hidden">
            <label for="login_age_36" class="age">36-50</label>
            <input v-model="age" id="login_age_50" type="radio" name="age" value="50" class="is-hidden">
            <label for="login_age_50" class="age">50+</label>
        </div>
        <br />
        <div id="login-headline"><h3>My Coach&rsquo;s Info</h3></div>
        <div id="login_coach">
            <label for="login_coach_name" class="is-hidden">Coach Name</label>
            <input v-model="coach_name" id="login_coach_name" type="text" name="coach_name" placeholder="Your Coach's Name">
            <label for="login_coach_email" class="is-hidden">Coach Email</label>
            <input v-model="coach_email" id="login_coach_email" type="text" name="coach_email" placeholder="Your Coach's Email Address">
        </div>
        <div class="get-coaching-link" v-if="!have_coach">
            <a href="/get-coaching">Don’t have a coach? Let us help you find one &rarr;</a>
        </div>
        <div v-show="submit_clicked && firstError" class="alert is-error">
            {{firstError}}
        </div>
        <div v-show="edit_successful" class="alert is-success">
            Your Info Was Successfully Updated
        </div>
        <button type="submit" @click.prevent="submit">Submit</button>
    </form>
</div>
</template>

<script>
/* eslint-disable */
import Axios from 'axios';

export default {
    name: 'Login',
    components: {
    },
    data: () => {
        return {
            age: '',
            email: '',
            first_name: '',
            last_name: '',
            email_confirm: '',
            coach_name: '',
            coach_email: '',
            have_coach: false,
            submit_clicked: false,
            server_error: '',
            edit_successful: false
        }
    },
    mounted: async function() {
        const res = await Axios.get('/user');
        const user = res.data && res.data.user;
        if (user) {
            this.email = user.email;
            this.email_confirm = user.email;
            this.first_name = user.first;
            this.last_name = user.last;
            this.age = user.age;
            this.coach_name = user.coachName;
            this.coach_email = user.coachEmail;
            this.have_coach = user.coachEmail ? true : false;
        }
    },
    computed: {
        validationResult: function () {
            const result = {};
            if (!this.first_name || !this.last_name) {
                result['login_first_name'] = 'Please enter your name';
            }
            if (!this.email) {
                result['login_email'] = 'Please enter your email address';
            }
            if (!this.validateEmail(this.email)) {
                result['login_email'] = 'Please enter a valid email address';
            }
            if (this.email !== this.email_confirm) {
                result['login_email_confirm'] = 'The email confirmation doesn\'t match. Please double check.';
            }
            if (!this.age) {
                result['age'] = 'Please select your age range';
            }
            if ((this.coach_name || this.coach_email) && (!this.coach_name || !this.coach_email)) {
                result['coach_name'] = 'Please finish entering your coach\'s information';
            }
            return result;
        },
        firstError: function() {
            if (this.server_error.length) {
                return this.server_error;
            }
            for(var key in this.validationResult) {
                return this.validationResult[key];
            }
            return '';
        }
    },
    methods: {
        submit: function () {
            this.submit_clicked = true;
            this.server_error = '';
            this.edit_successful = false;
            if (this.firstError) {
                return false;
            }

            const form = document.getElementById('form_start');
            const formData = new FormData(form);
            formData.set('email', encodeURIComponent(this.email));
            const router = this.$router;
            const vm = this;
            Axios.post('/user', formData).then(function (response) {
                if (!response.data.success && response.data.message && response.data.message.length) {
                    vm.server_error = response.data.message;
                } else {
                    vm.edit_successful = true;
                }
            });
        },
        validateEmail: function(email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    }
}
</script>
